export default function PHP_tmpfile() {
  return (
    <div>
      <h1>PHP_tmpfile</h1>
    </div>
  );
}
